module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_blue_en-4d636b0a337b65c2a756b6c6ae0802ce.png";